/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pll_Toast_Create_PnkInputs */

const vi_pll_toast_create_pnk = /** @type {(inputs: Pll_Toast_Create_PnkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã tạo phiếu nhập`)
};

/**

* @param {Pll_Toast_Create_PnkInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pll_toast_create_pnk = /** @type {((inputs?: Pll_Toast_Create_PnkInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pll_Toast_Create_PnkInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pll_toast_create_pnk(inputs)
});